var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 161,
    viewBox: "0 0 329 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0355225 152.416L10.4456 160.052L359 -201H341.218L0.0355225 152.416Z",
    fill: "#B6B0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 148.445H54.6008V160.73H0V148.445Z",
    fill: "#B6B0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.14441e-05 160.73L-1.41821e-05 106.129L12.2852 106.129L12.2852 160.73L-1.14441e-05 160.73Z",
    fill: "#B6B0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDown);
export default __webpack_public_path__ + "static/media/arrow-left-down.dca7cd6a241d125f02d448adda264357.svg";
export { ForwardRef as ReactComponent };